import React from "react";
import styles from "./PeopleUI.module.css";
import ResourceTypeIcon from "./ResourceTypeIcon";

const TYPE_ICON_CLASS = {
  vehicle: styles.resourceIconVehicle,
  tool: styles.resourceIconTool,
  misc: styles.resourceIconMisc,
};

const STATUS_CLASS = {
  available: styles.statusAvailable,
  in_use: styles.statusInUse,
  maintenance: styles.statusMaintenance,
  unavailable: styles.statusUnavailable,
};

const STATUS_LABEL = {
  available: "Available",
  in_use: "In use",
  maintenance: "Maintenance",
  unavailable: "Unavailable",
};

const TYPE_LABEL = {
  misc: "Miscellaneous",
  vehicle: "Vehicle",
  tool: "Tool / Equipment",
};

export default function ResourceCompactCard({ resource, onClick }) {
  const iconClass = TYPE_ICON_CLASS[resource.type] || styles.resourceIconMisc;
  const statusClass = STATUS_CLASS[resource.availability_status] || styles.statusUnavailable;
  const statusLabel = STATUS_LABEL[resource.availability_status] || resource.availability_status;
  const typeLabel = resource.type === "vehicle"
    ? (resource.registration_number || TYPE_LABEL.vehicle)
    : TYPE_LABEL[resource.type] || resource.type;

  return (
    <div
      onClick={onClick}
      className={`${styles.resourceCard} ${!resource.is_active ? styles.resourceCardArchived : ""}`}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      {!resource.is_active && (
        <span className={styles.archivedBadge}>Archived</span>
      )}
      <div className={`${styles.resourceIcon} ${iconClass}`} aria-hidden="true">
        <ResourceTypeIcon type={resource.type} />
      </div>
      <div className={styles.resourceCardBody}>
        <span className={styles.resourceCardName}>{resource.name}</span>
        <span className={styles.resourceCardMeta}>{typeLabel}</span>
      </div>
      <span className={`${styles.statusPill} ${statusClass}`}>
        <span className={styles.statusDot} aria-hidden="true" />
        {statusLabel}
      </span>
    </div>
  );
}
